var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbracePerseveranceFlexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5714,
    cy: 11.7857,
    r: 11.7857,
    fill: "#256BE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 20.3571L0 45H45V20.3571Z",
    fill: "#171C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbracePerseveranceFlexibility);
export default __webpack_public_path__ + "static/media/EmbracePerseverance&Flexibility.b47c998dc9fbd32678cf26075c6fd901.svg";
export { ForwardRef as ReactComponent };